/* eslint-disable no-self-assign */

/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

const INITIAL_STATE = { scrollTo: null, scrollBy: null, notifyData: null }

export default {
  namespace: 'app',

  state: INITIAL_STATE,

  reducers: {
    scrollTo(state, { payload }) {
      return { ...state, scrollTo: payload }
    },

    scrollBy(state, { payload }) {
      return { ...state, scrollBy: payload }
    },

    // Set payload with the following format
    // {
    //   message,   -- message to be shown --
    //   duration,  -- duration before message closes, default 6000 ms --
    // }
    notify(state, { payload }) {
      return { ...state, notifyData: payload }
    },
  },

  effects: {
    *initApp(_, { put }) {
      put({ type: 'profile/init' })
    },
  },
}
